export class LogColors
{
  static readonly reset = "\x1b[0m";
  static readonly bright = "\x1b[1m";
  static readonly dim = "\x1b[2m";
  static readonly underscore = "\x1b[4m";
  static readonly blink = "\x1b[5m";
  static readonly reverse = "\x1b[7m";
  static readonly hidden = "\x1b[8m";

  static readonly black_Foreground = "\x1b[30m";
  static readonly red_Foreground = "\x1b[31m";
  static readonly green_Foreground = "\x1b[32m";
  static readonly yellow_Foreground = "\x1b[33m";
  static readonly blue_Foreground = "\x1b[34m";
  static readonly magenta_Foreground = "\x1b[35m";
  static readonly cyan_Foreground = "\x1b[36m";
  static readonly white_Foreground = "\x1b[37m";
  static readonly gray_Foreground = "\x1b[90m";

  static readonly black_Background = "\x1b[40m";
  static readonly red_Background = "\x1b[41m";
  static readonly green_Background = "\x1b[42m";
  static readonly yellow_Background = "\x1b[43m";
  static readonly blue_Background = "\x1b[44m";
  static readonly magenta_Background = "\x1b[45m";
  static readonly cyan_Background = "\x1b[46m";
  static readonly white_Background = "\x1b[47m";
  static readonly gray_Background = "\x1b[100m";

}